import { useState, useEffect } from 'react'
import { cx } from '@/utils/strings'
import BwiClose from '@/icons/bwi/close.svg'
import { usePage } from '@inertiajs/react'
import HubspotForm from '@/components/ui/hubspot-form'
import Collapsible from '@/components/ui/collapsible'
import { TypeComponentHubSpotForm } from '@/types/ctf'

interface Props {
  form: TypeComponentHubSpotForm<'WITHOUT_UNRESOLVABLE_LINKS'>
}

export default function PageSuggestions({ form }: Props) {
  const [isOpen, setIsOpen] = useState(false)
  const page = usePage()

  useEffect(() => {
    if (isOpen) {
      const frm = document.getElementById('help-page-suggestions') as HTMLFormElement
      frm.scrollIntoView({ behavior: 'smooth' })
    }
    document.querySelectorAll('.hs_form_path')?.forEach((el) => {
      el.querySelector('input[type="hidden"]')?.setAttribute('value', page.url)
    })
  }, [isOpen])

  return (
    <div className="rounded-lg p-4 bg-secondary-50 relative dark:bg-secondary-800">
      <div className="w-full flex">
        <button
          type="button"
          className={cx(
            'bg-white rounded-lg text-primaryBlue dark:text-white self-end ml-auto h-auto py-2 whitespace-normal dark:hover:bg-secondary-900 transition-colors dark:bg-secondary-100 ',
            isOpen ? 'w-auto z-[2]' : 'w-full'
          )}
          onClick={() => {
            window.location.hash = 'help-page-suggestions'
            setIsOpen(!isOpen)
          }}
        >
          {isOpen ? (
            <BwiClose className="absolute right-3 top-4 lg:right-10 lg:top-14 h-8 w-8 p-2 mx-2 my-0 rounded hover:bg-gray-200 dark:hover:bg-gray-700" />
          ) : (
            form?.fields?.headline
          )}
        </button>
      </div>
      <div
        id="help-page-suggestions"
        className={`${isOpen ? '[&_button]:block ' : '[&_button]:hidden'} dark:[&_a]:text-primaryBlue dark:hover:[&_a]:text-primaryBlue`}
      >
        <Collapsible className={cx('text-sm overflow-hidden', isOpen && 'px-3 pb-3 lg:pb-8 lg:px-8')} isOpen={isOpen}>
          <HubspotForm {...form.fields} />
        </Collapsible>
      </div>
    </div>
  )
}
